import React, {useState, useEffect} from 'react';
import Swal from "sweetalert2";
import {connect} from "react-redux";

const NonPublicAccess = () => {

    //let primaryColor = " #58D2C3";
    let backgroundColorTheme =  " #454756";
    let baseColorTheme = " #FFFFFF";

    useEffect(()=>{
        backgroundColorTheme = (props.uiTheme && props.uiTheme==="light")?" #FFFFFF":" #454756";
        baseColorTheme = (props.uiTheme && props.uiTheme==="light")?" #454756":" #FFFFFF";
        displayPopup()
;    }, [])

    const displayPopup=()=>{
        console.log("popup");
        Swal.fire(
            {title: '<p style="color:' + baseColorTheme + ';">Formulaire</p>',
                html: '<p style="color:' + baseColorTheme + ';">Désolé. Cette action ne vous est pas encore accessible !</p>',
                background: backgroundColorTheme,
                width: '19rem',
                backdrop: true,
            })
    }

    return (
        <>

        </>
    );
};

const mapStateToProps = state => {
    return {
        entity: state.MeReducer.entity,
        subscription: state.MeReducer.subscription,
        uiTheme : state.AppReducer.ui_theme,
    }
}


const mapDispatchTProps = dispatch => {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchTProps)(NonPublicAccess);
